// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drivers-page {
  font-family: 'Inter', -apple-system, sans-serif;
  color: #1f2937;
  overflow-x: hidden;
}

/* RESTORED HERO STYLES */
.hero-banner-image {
  height: 380px;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.hero-content-wrapper {
  position: relative;
  z-index: 10;
  padding-bottom: 60px;
}

.hero-grid-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
  max-width: 1180px;
  margin: 0 auto;
}

.hero-left-column {
  flex: 1 1;
  padding-top: 430px;
}

.hero-text-new h1 {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #111827;
  line-height: 1.2;
}

.text-blue { color: #2563eb; }
.text-orange { color: #f97316; }

.hero-text-new .subtitle-text {
  color: #6b7280;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.hero-text-new .desc-text {
  color: #4b5563;
  line-height: 1.6;
  font-size: 1.05rem;
  margin-bottom: 40px;
}

.feature-item-new h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #111827;
}

.feature-item-new p {
  color: #4b5563;
  line-height: 1.6;
  font-size: 1.05rem;
}

.hero-right-column {
  flex: 0 0 450px;
  padding-top: 80px;
}

.registration-card {
  width: 100%;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.registration-card h2 {
  text-align: center;
  font-size: 1.8rem;
  color: #2563eb;
  font-weight: 700;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f8fafc;
  transition: all 0.3s;
}

.form-group input:focus {
  border-color: #2563eb;
  outline: none;
  background: white;
}

.submit-btn-old {
  width: 100%;
  padding: 14px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 15px;
}

.submit-btn-old:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
}

/* NEW REDESIGNED SECTIONS STYLES */
.features-container {
  padding: 100px 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 64px;
}

.section-header h2 {
  font-size: 2.25rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 16px;
}

.section-header p {
  font-size: 1.125rem;
  color: #64748b;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
}

.feature-card {
  padding: 40px;
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

.feature-card:hover {
  border-color: #2563eb;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.05);
  transform: translateY(-8px);
}

.icon-box {
  width: 56px;
  height: 56px;
  background: rgba(37, 99, 235, 0.05);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: #2563eb;
  font-size: 24px;
}

.feature-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #0f172a;
}

.feature-card p {
  color: #64748b;
  line-height: 1.6;
}

.how-it-works {
  background: #f8fafc;
  padding: 100px 24px;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.step-item {
  text-align: center;
}

.step-number {
  width: 48px;
  height: 48px;
  background: #2563eb;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin: 0 auto 24px;
  font-size: 18px;
  box-shadow: 0 0 0 10px rgba(37, 99, 235, 0.05);
}

.step-item h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.blue { color: #2563eb; }

/* MODERN APP SECTION */
.modern-app-section {
  padding: 100px 24px;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.app-download-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
}

.modern-app-card {
  background: #ffffff;
  border-radius: 32px;
  padding: 40px;
  position: relative;
  border: 1px solid #f1f5f9;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.modern-app-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 30px 60px rgba(37, 99, 235, 0.1);
  border-color: rgba(37, 99, 235, 0.2);
}

.app-badge {
  position: absolute;
  top: 0;
  right: 40px;
  padding: 8px 16px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  border-radius: 0 0 12px 12px;
  letter-spacing: 1px;
}

.app-badge.customer { background: #dbeafe; color: #1e40af; }
.app-badge.driver { background: #ffedd5; color: #9a3412; }

.app-card-content {
  display: flex;
  align-items: center;
  gap: 32px;
}

.app-text {
  flex: 1 1;
}

.app-text h3 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 12px;
}

.app-text p {
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 24px;
  line-height: 1.5;
}

.download-buttons img {
  height: 48px;
  transition: transform 0.2s;
}

.download-buttons img:hover {
  transform: scale(1.05);
}

.qr-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qr-code-modern {
  width: 120px;
  height: 120px;
  background: #f8fafc;
  border: 4px solid #ffffff;
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}

.qr-marker {
  position: absolute;
  width: 24px;
  height: 24px;
  border: 4px solid #1e293b;
  border-radius: 4px;
}

.qr-marker.top-left { top: 15px; left: 15px; }
.qr-marker.top-right { top: 15px; right: 15px; }
.qr-marker.bottom-left { bottom: 15px; left: 15px; }

.qr-dots-pattern {
  width: 40px;
  height: 40px;
  background-image: radial-gradient(#1e293b 2px, transparent 2px);
  background-size: 8px 8px;
  position: absolute;
  bottom: 15px;
  right: 15px;
}

.qr-box span {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
}

@media (max-width: 640px) {
  .app-download-grid {
    grid-template-columns: 1fr;
  }
  
  .app-card-content {
    flex-direction: column;
    text-align: center;
  }
  
  .download-buttons {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 1024px) {
  .hero-grid-layout {
    flex-direction: column;
    align-items: center;
  }
  .hero-left-column {
    padding-top: 40px;
    text-align: center;
  }
  .hero-right-column {
    padding-top: 20px;
    width: 100%;
    max-width: 450px;
  }
  .hero-banner-image {
    position: relative;
    height: 250px;
  }
}

@media (max-width: 768px) {
  .features-container,
  .how-it-works,
  .modern-app-section {
    padding: 40px 16px;
  }
  .section-header {
    margin-bottom: 30px;
  }
  .section-header h2 {
    font-size: 1.75rem;
    margin-bottom: 8px;
  }
  .feature-card {
    padding: 24px;
    border-radius: 16px;
  }
  .steps-grid {
    gap: 24px;
  }
  .step-number {
    margin-bottom: 16px;
  }
  .modern-app-card {
    padding: 24px;
    border-radius: 20px;
  }
  .app-card-content {
    gap: 16px;
  }
  .app-text h3 {
    font-size: 1.5rem;
  }
  .hero-content-wrapper {
    padding-bottom: 30px;
  }
  .registration-card {
    padding: 24px;
  }
  .registration-card h2 {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Drivers.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa,cAAc,EAAE;AAC7B,eAAe,cAAc,EAAE;;AAE/B;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,QAAQ,cAAc,EAAE;;AAExB,uBAAuB;AACvB;EACE,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB,SAAS,EAAE,UAAU,EAAE;AAC7C,uBAAuB,SAAS,EAAE,WAAW,EAAE;AAC/C,yBAAyB,YAAY,EAAE,UAAU,EAAE;;AAEnD;EACE,WAAW;EACX,YAAY;EACZ,+DAA+D;EAC/D,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".drivers-page {\n  font-family: 'Inter', -apple-system, sans-serif;\n  color: #1f2937;\n  overflow-x: hidden;\n}\n\n/* RESTORED HERO STYLES */\n.hero-banner-image {\n  height: 380px;\n  background-size: cover;\n  background-position: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 0;\n}\n\n.banner-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.hero-content-wrapper {\n  position: relative;\n  z-index: 10;\n  padding-bottom: 60px;\n}\n\n.hero-grid-layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 60px;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.hero-left-column {\n  flex: 1;\n  padding-top: 430px;\n}\n\n.hero-text-new h1 {\n  font-size: 2.25rem;\n  font-weight: 800;\n  margin-bottom: 15px;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.text-blue { color: #2563eb; }\n.text-orange { color: #f97316; }\n\n.hero-text-new .subtitle-text {\n  color: #6b7280;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.hero-text-new .desc-text {\n  color: #4b5563;\n  line-height: 1.6;\n  font-size: 1.05rem;\n  margin-bottom: 40px;\n}\n\n.feature-item-new h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #111827;\n}\n\n.feature-item-new p {\n  color: #4b5563;\n  line-height: 1.6;\n  font-size: 1.05rem;\n}\n\n.hero-right-column {\n  flex: 0 0 450px;\n  padding-top: 80px;\n}\n\n.registration-card {\n  width: 100%;\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n}\n\n.registration-card h2 {\n  text-align: center;\n  font-size: 1.8rem;\n  color: #2563eb;\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: #f8fafc;\n  transition: all 0.3s;\n}\n\n.form-group input:focus {\n  border-color: #2563eb;\n  outline: none;\n  background: white;\n}\n\n.submit-btn-old {\n  width: 100%;\n  padding: 14px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s;\n  margin-top: 15px;\n}\n\n.submit-btn-old:hover {\n  background: #1d4ed8;\n  transform: translateY(-2px);\n}\n\n/* NEW REDESIGNED SECTIONS STYLES */\n.features-container {\n  padding: 100px 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-header {\n  text-align: center;\n  max-width: 700px;\n  margin: 0 auto 64px;\n}\n\n.section-header h2 {\n  font-size: 2.25rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 16px;\n}\n\n.section-header p {\n  font-size: 1.125rem;\n  color: #64748b;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 32px;\n}\n\n.feature-card {\n  padding: 40px;\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #f1f5f9;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);\n}\n\n.feature-card:hover {\n  border-color: #2563eb;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.05);\n  transform: translateY(-8px);\n}\n\n.icon-box {\n  width: 56px;\n  height: 56px;\n  background: rgba(37, 99, 235, 0.05);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  color: #2563eb;\n  font-size: 24px;\n}\n\n.feature-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #0f172a;\n}\n\n.feature-card p {\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.how-it-works {\n  background: #f8fafc;\n  padding: 100px 24px;\n}\n\n.steps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.step-item {\n  text-align: center;\n}\n\n.step-number {\n  width: 48px;\n  height: 48px;\n  background: #2563eb;\n  color: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  margin: 0 auto 24px;\n  font-size: 18px;\n  box-shadow: 0 0 0 10px rgba(37, 99, 235, 0.05);\n}\n\n.step-item h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.blue { color: #2563eb; }\n\n/* MODERN APP SECTION */\n.modern-app-section {\n  padding: 100px 24px;\n  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);\n}\n\n.app-download-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 32px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.modern-app-card {\n  background: #ffffff;\n  border-radius: 32px;\n  padding: 40px;\n  position: relative;\n  border: 1px solid #f1f5f9;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.modern-app-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 30px 60px rgba(37, 99, 235, 0.1);\n  border-color: rgba(37, 99, 235, 0.2);\n}\n\n.app-badge {\n  position: absolute;\n  top: 0;\n  right: 40px;\n  padding: 8px 16px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  border-radius: 0 0 12px 12px;\n  letter-spacing: 1px;\n}\n\n.app-badge.customer { background: #dbeafe; color: #1e40af; }\n.app-badge.driver { background: #ffedd5; color: #9a3412; }\n\n.app-card-content {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.app-text {\n  flex: 1;\n}\n\n.app-text h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 12px;\n}\n\n.app-text p {\n  font-size: 1rem;\n  color: #64748b;\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.download-buttons img {\n  height: 48px;\n  transition: transform 0.2s;\n}\n\n.download-buttons img:hover {\n  transform: scale(1.05);\n}\n\n.qr-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.qr-code-modern {\n  width: 120px;\n  height: 120px;\n  background: #f8fafc;\n  border: 4px solid #ffffff;\n  border-radius: 20px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.qr-marker {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  border: 4px solid #1e293b;\n  border-radius: 4px;\n}\n\n.qr-marker.top-left { top: 15px; left: 15px; }\n.qr-marker.top-right { top: 15px; right: 15px; }\n.qr-marker.bottom-left { bottom: 15px; left: 15px; }\n\n.qr-dots-pattern {\n  width: 40px;\n  height: 40px;\n  background-image: radial-gradient(#1e293b 2px, transparent 2px);\n  background-size: 8px 8px;\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n}\n\n.qr-box span {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n}\n\n@media (max-width: 640px) {\n  .app-download-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .app-card-content {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .download-buttons {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 1024px) {\n  .hero-grid-layout {\n    flex-direction: column;\n    align-items: center;\n  }\n  .hero-left-column {\n    padding-top: 40px;\n    text-align: center;\n  }\n  .hero-right-column {\n    padding-top: 20px;\n    width: 100%;\n    max-width: 450px;\n  }\n  .hero-banner-image {\n    position: relative;\n    height: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .features-container,\n  .how-it-works,\n  .modern-app-section {\n    padding: 40px 16px;\n  }\n  .section-header {\n    margin-bottom: 30px;\n  }\n  .section-header h2 {\n    font-size: 1.75rem;\n    margin-bottom: 8px;\n  }\n  .feature-card {\n    padding: 24px;\n    border-radius: 16px;\n  }\n  .steps-grid {\n    gap: 24px;\n  }\n  .step-number {\n    margin-bottom: 16px;\n  }\n  .modern-app-card {\n    padding: 24px;\n    border-radius: 20px;\n  }\n  .app-card-content {\n    gap: 16px;\n  }\n  .app-text h3 {\n    font-size: 1.5rem;\n  }\n  .hero-content-wrapper {\n    padding-bottom: 30px;\n  }\n  .registration-card {\n    padding: 24px;\n  }\n  .registration-card h2 {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
